var shape = {
  borderRadius: 4
};
export default shape;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/styles/shape.js
// module id = 453
// module chunks = 0